export const GAME_VERSION = '1.0.2'
